import React from "react";
import {
  DashboardHourlyBarChart,
  HourlyBarDatum,
} from "../DashboardHourlyBarChart";

interface ArrivalChartProps {
  metricScale?: number;
  data?: HourlyBarDatum[];
}

export const ArrivalChart: React.FC<ArrivalChartProps> = ({
  metricScale = 0,
  data,
}) => {
  return (
    <DashboardHourlyBarChart
      primaryLabel="Arrivals"
      secondaryLabel="Pre Check-ins"
      metricScale={metricScale}
      data={data}
    />
  );
};
